var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.907 28.776A8.498 8.498 0 0 1 11 20.415c0-4.69 3.824-8.515 8.511-8.515 1.943 0 3.855.679 5.335 1.913l.216.154 2.497-2.499h-3.268V9H32v7.713h-2.467v-3.301l-2.713 2.653.092.216c.71 1.234 1.08 2.684 1.08 4.134 0 4.072-2.93 7.59-6.939 8.36a7.433 7.433 0 0 1-3.146 0Zm1.573-14.192c-3.207 0-5.828 2.622-5.828 5.83 0 3.21 2.59 5.862 5.828 5.862 3.238 0 5.828-2.622 5.828-5.861 0-3.24-2.62-5.831-5.828-5.831Z",
    fill: "#fff"
  })));
};
export default SvgMale;